const qaConfigs = {
  ntm_script:
    '!function(t,n){n=n||"ntm";window["ntm_"+t]=n,window[n]=window[n]||[],window[n].push({"ntm.start":+new Date});t=document.getElementsByTagName("script")[0],n=document.createElement("script");n.async=!0,n.src="https://ntm-cdn.navercorp.com/scripts/ntm_9734f1409056_dev.js",t.parentNode.insertBefore(n,t)}("9734f1409056","ntm");',
  g_ssc: 'Mplace.placemy',
  g_query: 'test',
  ccsrv: 'alpha-cc.naver.com',
  naverAnalytics: {
    // key는 router와 동일하게.
    // https://oss.navercorp.com/place/local/issues/3682
    applyBetaTester: '11a595bbfddcc8',
    normal: '3bdb43ad08a89c',
  },
  gfpAdCallParam: {
    adSlotInfo: {
      adSlotElementId: 'myplace_gd',
      uct: 'KR',
    },
    config: {
      debug: true,
      phase: 'test',
    },
  },
} as const

export default qaConfigs
